import config from "../config/config";
import axios from 'axios';

export function doGetCall(url) {
    let headers = new Headers();
    let encodedString = new Buffer.from(config.BASIC_AUTH_USERNAME+':'+config.BASIC_AUTH_PASSOWRD).toString('base64');
    headers.append('Authorization', 'Basic ' + encodedString);
    
    return fetch(config.API_URL+url,{
        headers: headers,
    })
    .then(handleErrors)
    .then(res => res.json());
}

export function doPostCall(url,data,headers) {
  return axios.post(config.API_URL+url, data, {
    auth:{
      username:config.BASIC_AUTH_USERNAME,
      password:config.BASIC_AUTH_PASSOWRD
    }, 
    headers: headers
  })
}

// Handle HTTP errors since fetch won't.
function handleErrors(response) {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  }